"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _RedirectWithCountdownModule = _interopRequireDefault(require("./RedirectWithCountdown.module.css"));
var RedirectWithCountdown = function RedirectWithCountdown(props) {
  var secondsToCountdown = props.secondsToCountdown,
    showRedirectText = props.showRedirectText,
    redirectText = props.redirectText,
    redirectTextClass = props.redirectTextClass,
    redirectTextFunc = props.redirectTextFunc;
  var _useState = (0, _react.useState)(undefined),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    setCountdownTimeout = _useState2[1];
  var _useState3 = (0, _react.useState)(secondsToCountdown),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    secondsRemaining = _useState4[0],
    setSecondsRemaining = _useState4[1];
  var countDown = (0, _react.useCallback)(function () {
    if (secondsRemaining < 1) {
      window.location.assign(props.targetUrl);
    } else {
      setSecondsRemaining(secondsRemaining - 1);
    }
  }, [props.targetUrl, secondsRemaining]);
  (0, _react.useEffect)(function () {
    setCountdownTimeout(setTimeout(countDown, 1000));
  }, [countDown]);
  var renderRedirectText = function renderRedirectText() {
    if (!showRedirectText) return null;
    if (redirectTextFunc) return redirectTextFunc(secondsRemaining);
    return /*#__PURE__*/_react["default"].createElement("p", {
      className: redirectTextClass,
      "data-testid": "RedirectText"
    }, redirectText, " ", secondsRemaining, "...");
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "ExternalRedirect"
  }, props.children, /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("br", null), renderRedirectText());
};
RedirectWithCountdown.defaultProps = {
  targetUrl: undefined,
  secondsToCountdown: 3,
  redirectText: 'Redirecting In',
  showRedirectText: true,
  redirectTextClass: _RedirectWithCountdownModule["default"].redirectText,
  redirectTextFunc: undefined
};
var _default = RedirectWithCountdown;
exports["default"] = _default;